import React, { useContext, useEffect, useState } from 'react'

import { useNavigate } from 'react-router-dom'

import { CondominiumConditionType, EstateContext } from '@/hooks/useEstateContext'
import { Spacing } from '@inter/inter-ui/components/Spacing'
import { Button } from '@inter/inter-ui/components/Button'
import { Text } from '@inter/inter-ui/components/Text'
import { Flex } from '@inter/inter-ui/components/Flex'
import { RadioGroup } from '@inter/inter-ui/components/RadioGroup'
import RadioCard from '@/components/RadioCard'
import routes from '@/routes/RoutesNames'

import options from './options.json'

const CondominiumCondition = () => {
  const { condominiumCondition, setCondominiumCondition, setStep } = useContext(EstateContext)
  const [selected, setSelected] = useState<CondominiumConditionType>('' as CondominiumConditionType)
  const navigate = useNavigate()

  useEffect(() => {
    setStep(5)
    setSelected(condominiumCondition)
  }, [condominiumCondition, setStep])

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setCondominiumCondition(selected)
    navigate(`/${routes.FORM_REVIEW}`)
  }

  return (
    <form onSubmit={(event) => onSubmit(event)}>
      <Flex direction="column" justifyContent="space-between">
        <Text variant="headline-h3" semiBold>
          Qual o estado de conservação do condomínio?
        </Text>
        <Spacing mb="xxs" />
        <Text variant="body-3">Avalie a infraestrutura das áreas comuns do seu condomínio:</Text>
        <Spacing mb="lg" />
        <RadioGroup
          name="options"
          value={selected}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setSelected(event.target.value as CondominiumConditionType)
          }
          style={{ display: 'flex' }}
        >
          <Flex direction="column">
            {Object.keys(options).map((option) => (
              <React.Fragment key={option}>
                <RadioCard
                  id={`condominium-condition-${option.toLowerCase().replace('_', '-')}`}
                  value={option}
                  title={options[option as CondominiumConditionType].title}
                  description={options[option as CondominiumConditionType].description}
                />
                <Spacing mb="xs" />
              </React.Fragment>
            ))}
          </Flex>
        </RadioGroup>

        <Spacing mb="sm" />
        <Button type="submit" fullWidth disabled={!selected}>
          Continuar
        </Button>
      </Flex>
    </form>
  )
}

export default CondominiumCondition
